export default "__VITE_ASSET__68e20aa1__"